export function getDefaultFeatureColor(dt) {
    switch (dt.themeVariant) {
        case 'high-contrast':
        case 'dark':
            return dt.c.white;
        default:
            return dt.c.black;
    }
}
export function getFeatureTokens(dt, feature) {
    var _a;
    return {
        fg: (_a = feature.color) !== null && _a !== void 0 ? _a : getDefaultFeatureColor(dt),
    };
}
/**
 * High contrast selection inverts colors. These styles invert colors again so
 * elements display in their original color.
 */
export function preventColorInversionStyles(item, color) {
    return item.selected && color !== null ? { filter: 'var(--table-selected-internal-filter)' } : {};
}
